// Formatos de Volumen.

const fmt = (value: number, digits: number) =>
  value.toLocaleString('es-CL', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

// Millones de kilos: "569,5".
export const mkg = (kilos: number | null | undefined, digits = 1) =>
  fmt((kilos ?? 0) / 1e6, digits);

// Miles sin decimales ("569.502"); bajo 1, "<1" (no "0").
export const thousands = (value: number | null | undefined) => {
  const v = value ?? 0;
  if (v > 0 && v < 1) return '<1';
  return fmt(v, 0);
};

// Proporción (0,0195) como porcentaje: "1,95%".
export const pct = (value: number | null | undefined, digits = 1) =>
  value == null ? '—' : `${fmt(value * 100, digits)}%`;

// Variación (−0,09) con signo: "−9,0%".
export const signedPct = (value: number | null | undefined, digits = 1) =>
  value == null ? '—' : `${value > 0 ? '+' : ''}${fmt(value * 100, digits)}%`;

// Puntos porcentuales con signo: "+0,6".
export const pts = (value: number | null | undefined, digits = 1) =>
  value == null ? '—' : `${value > 0 ? '+' : ''}${fmt(value, digits)}`;

const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
// "2026-02-19" → "19-feb-2026".
export const day = (iso: string | null | undefined) => {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  return `${String(d).padStart(2, '0')}-${MONTHS[m - 1]}-${y}`;
};

// Rango de una semana: "16–22 feb", o "29 dic–4 ene" si cruza de mes.
export const dayRange = (from: string, to: string) => {
  const [, fm] = from.split('-').map(Number);
  const [, tm] = to.split('-').map(Number);
  const fd = Number(from.slice(8, 10));
  const td = Number(to.slice(8, 10));
  return fm === tm
    ? `${fd}–${td} ${MONTHS[tm - 1]}`
    : `${fd} ${MONTHS[fm - 1]}–${td} ${MONTHS[tm - 1]}`;
};

// "2025-2026" → "25-26".
export const seasonShort = (season: string | undefined) =>
  season ? season.split('-').map((y) => y.slice(2)).join('-') : '';

export const week = (value: number | null | undefined) =>
  value == null ? '—' : String(value).padStart(2, '0');

// Verde si crece, rojo si cae (para chips y textos de variación).
export const toneOf = (value: number | null | undefined) =>
  value == null || Math.abs(value) < 1e-9 ? 'default' : value > 0 ? 'success' : 'danger';
